module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-445.81ad2fa.woff2";